import React from 'react';
import {
  DollarSignIcon,
  BuildingIcon,
  ClockIcon,
  HeartIcon } from
'lucide-react';
export function Personas() {
  const benefits = [
  {
    name: 'Cost-Effective Solutions',
    bulletPoints: [
    'Save up to 80% compared to traditional management',
    'Pricing designed for small buildings',
    'No hidden fees, no kickbacks — ever'],

    highlight: 'Save over AUD $5,500 annually',
    icon: DollarSignIcon
  },
  {
    name: 'Simplified Management',
    bulletPoints: [
    'Only the features you really need',
    'Clear, no-fuss communication tools',
    'Easy, transparent financial tracking'],

    highlight: 'Setup in under 30 minutes',
    icon: ClockIcon
  },
  {
    name: 'Quick & Connected',
    bulletPoints: [
    'Streamlined voting and decision-making',
    'Fast communication channels',
    'Built to support small owner groups'],

    highlight: 'Decisions in days, not months',
    icon: BuildingIcon
  },
  {
    name: 'Community First',
    bulletPoints: [
    'Strengthen neighbour connections',
    'Keep things simple yet professional',
    'Full control, no lock-in contracts, and data you can take with you'],

    highlight: 'Built for community living',
    icon: HeartIcon
  }];

  return (
    <div id="personas" className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">
            Small Property Benefits
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Why Small Buildings Choose StrataPro
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            Traditional strata management is built for large complexes. We're
            specifically designed for small apartment blocks, duplexes, and
            townhouses.
          </p>
        </div>
        <div className="mt-10">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {benefits.map((benefit) =>
              <div key={benefit.name} className="flex flex-col">
                  <div className="flex items-center mb-3">
                    <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-500 text-white">
                      <benefit.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <div className="ml-3">
                      <h3 className="text-lg font-medium text-gray-900">
                        {benefit.name}
                      </h3>
                    </div>
                  </div>
                  <ul className="space-y-2 mt-2 pl-12">
                    {benefit.bulletPoints.map((point, index) =>
                  <li key={index} className="flex items-start">
                        <div className="flex-shrink-0 mt-1.5">
                          <div className="h-2 w-2 rounded-full bg-blue-500"></div>
                        </div>
                        <p className="ml-3 text-sm text-gray-600">{point}</p>
                      </li>
                  )}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="mt-12 text-center">
          <img
            className="mx-auto rounded-lg shadow-lg"
            width="570"
            src="/capi_d3652485ce105bd44f0a442a0e9eca7c_a4f570ab073e401363879efcf5aba6a1_7305888061b.jpg"
            alt="Classic Art Deco brick apartment building with curved features and balconies" />

        </div>
      </div>
    </div>);

}